import { render, staticRenderFns } from "./AppAnnotationPart7.vue?vue&type=template&id=8495dc78&scoped=true"
import script from "./AppAnnotationPart7.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart7.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart7.vue?vue&type=style&index=0&id=8495dc78&prod&lang=css"
import style1 from "./AppAnnotationPart7.vue?vue&type=style&index=1&id=8495dc78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8495dc78",
  null
  
)

export default component.exports